<script setup name="Template6">
import { inject, ref, onMounted, onUnmounted, computed } from "vue";
import ContainerCom from "./ContainerCom.vue";
import TextCom from "./TextCom.vue";
const templateRef = ref(null);
let observer = null;
const scrollValue = ref(0);
const stepList = [0, 200];
// 为模板组件定义属性
const props = defineProps({
  templateId: {
    type: String,
    default: "",
  },
});
// 是否是移动端
const isMobile = ref(window.innerWidth <= 768);
const isLoggedIn = inject("isLoggedIn");
// 处理删除事件
const handleDelete = (contentId) => {
  // emit删除事件
  emit("handleDelete", props.templateId);
};
// 监听滑动事件
const handleScroll = (e) => {
  if (e.deltaY > 0) {
    // 下滑 - 放大firstText
    scrollValue.value = scrollValue.value + e.deltaY; // 最大放大到10倍
    if (scrollValue.value >= stepList[stepList.length - 1]) {
      // 到达最大缩放比例，停止放大
      enableScroll();
      //  stopScrollListening()
    }
  } else if (e.deltaY < 0) {
    // 上滑 - 缩小firstText
    scrollValue.value = scrollValue.value + e.deltaY;
    if (scrollValue.value <= stepList[0]) {
      // 到达最大缩放比例，停止放大
      enableScroll();
      //  stopScrollListening()
    }
  }
};
// 停止页面滚动
const lockScroll = () => {
  const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
  const scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

  // 固定页面位置
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollTop}px`;
  document.body.style.left = `-${scrollLeft}px`;
};

// 恢复页面滚动
const enableScroll = () => {
  console.log("enableScroll");
  const bodyStyle = document.body.style;
  const top = bodyStyle.top;

  if (bodyStyle.position === "fixed") {
    // 恢复滚动位置
    document.body.style.position = "";
    document.body.style.top = "";
    document.body.style.left = "";
    window.scrollTo(0, parseInt(top || "0") * -1);
  }
};
// 处理交叉观察器回调 - 检测模板是否可见
const handleIntersect = (entries) => {
  entries.forEach((entry) => {
    if (entry.isIntersecting) {
      setTimeout(() => {
        // 当模板可见时，开始监听滑动事件
        startScrollListening();
        lockScroll();
      }, 50);
    } else {
      setTimeout(() => {
        // 当模板不可见时，停止监听滑动事件
        stopScrollListening();
        // 恢复正常滑动
        enableScroll();
      }, 50);
    }
  });
};
// 开始监听滑动事件
const startScrollListening = () => {
  window.addEventListener("wheel", handleScroll);
};

// 停止监听滑动事件
const stopScrollListening = () => {
  window.removeEventListener("scroll", handleScroll);
};
// 定义emits
const emit = defineEmits(["edit", "handleDelete"]);
// 生命周期钩子
onMounted(() => {
  // 初始化交叉观察器，检测模板是否可见
  // 判断是否是移动端
  if (window.innerWidth <= 768) {
    // 移动端不使用交叉观察器
    return;
  }
  observer = new IntersectionObserver(handleIntersect, {
    threshold: 0.95, // 当100%的元素可见时触发
  });
  if (templateRef.value) {
    observer.observe(templateRef.value);
  }
});

onUnmounted(() => {
  // 清理交叉观察器
  if (observer && templateRef.value) {
    observer.unobserve(templateRef.value);
    observer.disconnect();
  }

  // 清理事件监听器
  stopScrollListening();

  // 确保恢复滚动
  enableScroll();
});
const style1 = computed(() => ({
  opacity: 1 - scrollValue.value / stepList[1],
}));
const style2 = computed(() => ({
  opacity: scrollValue.value / stepList[1],
}));
const ContainerStyle = computed(() => {
  // 计算padding值，确保最小值为0，最大值为2rem和4rem
  // 获取当前屏幕宽度
  const screenWidth = window.innerWidth;
  // 根据屏幕宽度调整padding值
  const paddingTopBottom =
    (window.innerWidth / 1600) *
    Math.max(0, Math.min(2, 2 - (2 * scrollValue.value) / stepList[1]));
  const paddingLeftRight =
    (window.innerWidth / 1600) *
    Math.max(0, Math.min(4, 4 - (4 * scrollValue.value) / stepList[1]));

  return {
    padding: `${paddingTopBottom}rem ${paddingLeftRight}rem`,
  };
});
</script>

<!-- 添加组件描述注释 -->
<!-- 6号模板组件：技术原理页面，包含标题、描述、图表和数据指标 -->

<template>
  <div class="template-7" ref="templateRef" :style="ContainerStyle">
    <div class="first-content">
      <div class="first-container">
        <ContainerCom
          :contentId="props.templateId + '-container-1'"
          :style="style1"
          :allowFullScreenPlay="false"
          :showDelete="isLoggedIn"
          :showOrderNum="true"
          @order="emit('order', $event)"
          @delete="handleDelete"
        >
          <div class="content-container">
            <div>
              <TextCom :contentId="props.templateId + '-text-1'" />
            </div>
            <div>
              <TextCom :contentId="props.templateId + '-text-2'" />
            </div>
            <div>
              <TextCom :contentId="props.templateId + '-text-3'" />
            </div>
          </div>
        </ContainerCom>
      </div>
      <div class="second-content" :style="isMobile ? {} : style2">
        <ContainerCom
          :allowFullScreenPlay="false"
          :contentId="props.templateId + '-container-2'"
          class="second-container"
          :showDelete="isLoggedIn"
          :showOrderNum="true"
          @order="emit('order', $event)"
          @delete="handleDelete"
        >
          <div class="second-content-container">
            <TextCom :contentId="props.templateId + '-text-4'" />
            <TextCom
              :contentId="props.templateId + '-text-5'"
              class="second-text"
            />
            <div class="person-container">
              <img src="../assets/person.png" class="person-image" />
              <div class="point point-1"></div>
              <div class="point point-2"></div>
              <div class="point point-3"></div>
              <div class="point point-4"></div>
              <div class="point point-5"></div>
              <div class="point point-6"></div>
              <div class="point point-7"></div>
              <div class="left-arrow left-arrow-1">
                <TextCom
                  :contentId="props.templateId + '-text-6'"
                  :fontScale="1.2"
                />
                <TextCom
                  :contentId="props.templateId + '-text-7'"
                  :fontScale="0.8"
                />
              </div>
              <div class="left-arrow left-arrow-2">
                <TextCom
                  :contentId="props.templateId + '-text-8'"
                  :fontScale="1.2"
                />
                <TextCom
                  :contentId="props.templateId + '-text-9'"
                  :fontScale="0.8"
                />
              </div>
              <div class="left-arrow left-arrow-3">
                <TextCom
                  :contentId="props.templateId + '-text-10'"
                  :fontScale="1.2"
                />
                <TextCom
                  :contentId="props.templateId + '-text-11'"
                  :fontScale="0.8"
                />
              </div>
              <div class="left-arrow left-arrow-4">
                <TextCom
                  :contentId="props.templateId + '-text-12'"
                  :fontScale="1.2"
                />
                <TextCom
                  :contentId="props.templateId + '-text-13'"
                  :fontScale="0.8"
                />
              </div>
              <div class="right-arrow right-arrow-1">
                <TextCom
                  :contentId="props.templateId + '-text-14'"
                  :fontScale="1.2"
                />
                <TextCom
                  :contentId="props.templateId + '-text-15'"
                  :fontScale="0.8"
                />
              </div>
              <div class="right-arrow right-arrow-2">
                <TextCom
                  :contentId="props.templateId + '-text-16'"
                  :fontScale="1.2"
                />
                <TextCom
                  :contentId="props.templateId + '-text-17'"
                  :fontScale="0.8"
                />
              </div>
              <div class="right-arrow right-arrow-3">
                <TextCom
                  :contentId="props.templateId + '-text-18'"
                  :fontScale="1.2"
                />
                <TextCom
                  :contentId="props.templateId + '-text-19'"
                  :fontScale="0.8"
                />
              </div>
            </div>
          </div>
        </ContainerCom>
      </div>
    </div>
  </div>
  <!-- 使用ContainerCom作为主容器 -->
</template>

<style scoped>
.template-7 {
  height: 100vh;
  padding: 2rem 4rem;
}
.content-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.first-content {
  height: 100%;
  /* margin: 2rem 4rem; */
  border-radius: 20px;
  overflow: hidden;
  position: relative;
  /* border: 1px solid #000; */
}
.second-container {
  display: flex;
  justify-content: center;
  align-items: center;
}
.second-content-container {
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.first-container {
  height: 100vh;
}
.second-content {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  opacity: 0;
}
.person-container {
  transform: translateX(-32px);
  position: relative;
}
.second-text {
  margin-bottom: 2rem;
}
.person-image {
  height: 665px;
  width: 259px;
}
.point {
  position: absolute;
  width: 12px;
  height: 12px;
  background-color: #4a90e2;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(74, 144, 226, 0.7);
  animation: pulse 2s infinite;
}
.point-1 {
  top: 120px;
  left: 120px;
}
.point-2 {
  top: 300px;
  left: 103px;
}
.point-3 {
  top: 470px;
  left: 70px;
}
.point-4 {
  top: 510px;
  left: 45px;
}
.point-5 {
  top: 250px;
  left: 190px;
}
.point-6 {
  top: 520px;
  left: 175px;
}
.point-7 {
  top: 615px;
  left: 185px;
}
.left-arrow {
  position: absolute;
  height: 105px;
  width: 300px;
  background-image: url("../assets/arrow-left-blue.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  /* align-items: center; */
  padding: 1rem 3rem;
}
.left-arrow-1 {
  top: 50px;
  left: -170px;
}
.left-arrow-2 {
  top: 250px;
  left: -200px;
}
.left-arrow-3 {
  top: 370px;
  left: -180px;
}
.left-arrow-4 {
  top: 500px;
  left: -240px;
}

.right-arrow {
  position: absolute;
  height: 105px;
  width: 300px;
  background-image: url("../assets/arrow-right-blue.png");
  background-size: 100% auto;
  background-repeat: no-repeat;
  background-position: center center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1rem 3rem;
}
.right-arrow-1 {
  top: 200px;
  left: 260px;
}
.right-arrow-2 {
  top: 430px;
  left: 210px;
}
.right-arrow-3 {
  top: 550px;
  left: 230px;
}
@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba(74, 144, 226, 0.7);
    transform: scale(1);
  }
  70% {
    box-shadow: 0 0 0 1rem rgba(74, 144, 226, 0);
    transform: scale(1);
  }
  100% {
    box-shadow: 0 0 0 0 rgba(74, 144, 226, 0);
    transform: scale(1);
  }
}
:deep(.content-container) {
  border-radius: 20px;
}

/* 移动端适配 */
@media (max-width: 1024px) {
  /* 调整模板基本样式 */
  .template-7 {
    /* height: auto; */
    min-height: 100vh;
    padding: 1.5rem 2rem;
  }

  /* 调整人物图像大小 */
  .person-image {
    height: 500px;
    width: 194px;
  }

  /* 调整箭头尺寸，避免重叠 */
  .left-arrow,
  .right-arrow {
    height: 12vw;
    width: 28vw;
    padding: 0.8rem 2rem;
  }

  /* 调整点的位置 */
  .point-1 {
    top: 90px;
    left: 90px;
  }
  .point-2 {
    top: 225px;
    left: 77px;
  }
  .point-3 {
    top: 350px;
    left: 52px;
  }
  .point-4 {
    top: 380px;
    left: 34px;
  }
  .point-5 {
    top: 185px;
    left: 142px;
  }
  .point-6 {
    top: 390px;
    left: 131px;
  }
  .point-7 {
    top: 460px;
    left: 139px;
  }

  /* 调整箭头位置，避免重叠 */
  .left-arrow-1 {
    top: 20px;
    left: -130px;
  }
  .left-arrow-2 {
    top: 150px;
    left: -120px;
  }
  .left-arrow-3 {
    top: 250px;
    left: -140px;
  }
  .left-arrow-4 {
    top: 340px;
    left: -180px;
  }
  .right-arrow-1 {
    top: 120px;
    left: 210px;
  }
  .right-arrow-2 {
    top: 280px;
    left: 170px;
  }
  .right-arrow-3 {
    top: 380px;
    left: 180px;
  }
}

@media (max-width: 768px) {
  /* 进一步调整模板基本样式 */
  .template-7 {
    padding: 1rem 1.5rem;
  }

  /* 调整人物图像大小 */
  .person-image {
    height: 380px;
    width: 150px;
  }
  .template-7 {
    height: auto;
  }
  /* 调整箭头尺寸，避免重叠 */
  .left-arrow,
  .right-arrow {
    height: 14vw;
    width: 35vw;
    padding: 0.6rem 1.5rem;
  }
  .first-content {
    height: auto;
    overflow: none;
  }

  .second-content {
    position: relative;
    top: 0;
    left: 0;
    height: 100vh;
    width: 100%;
    opacity: 1;
  }

  /* 调整点的位置 */
  .point-1 {
    top: 70px;
    left: 70px;
  }
  .point-2 {
    top: 170px;
    left: 58px;
  }
  .point-3 {
    top: 265px;
    left: 40px;
  }
  .point-4 {
    top: 285px;
    left: 25px;
  }
  .point-5 {
    top: 140px;
    left: 110px;
  }
  .point-6 {
    top: 295px;
    left: 100px;
  }
  .point-7 {
    top: 350px;
    left: 105px;
  }

  /* 调整箭头位置，避免重叠 */
  .left-arrow-1 {
    top: 10px;
    left: -110px;
  }
  .left-arrow-2 {
    top: 120px;
    left: -100px;
  }
  .left-arrow-3 {
    top: 200px;
    left: -120px;
  }
  .left-arrow-4 {
    top: 260px;
    left: -150px;
  }
  .right-arrow-1 {
    top: 100px;
    left: 160px;
  }
  .right-arrow-2 {
    top: 220px;
    left: 130px;
  }
  .right-arrow-3 {
    top: 300px;
    left: 140px;
  }
}

@media (max-width: 480px) {
  /* 调整模板基本样式 */
  .template-7 {
    padding: 0.5rem 1rem;
  }

  /* 调整人物图像大小 */
  .person-image {
    height: 300px;
    width: 120px;
  }

  /* 调整箭头尺寸，避免重叠 */
  .left-arrow,
  .right-arrow {
    height: 13vw;
    width: 40vw;
    padding: 0.5rem 1.2rem;
    background-size: cover;
  }

  /* 调整点的位置 */
  .point-1 {
    top: 55px;
    left: 55px;
  }
  .point-2 {
    top: 135px;
    left: 46px;
  }
  .point-3 {
    top: 210px;
    left: 32px;
  }
  .point-4 {
    top: 230px;
    left: 20px;
  }
  .point-5 {
    top: 110px;
    left: 85px;
  }
  .point-6 {
    top: 235px;
    left: 77px;
  }
  .point-7 {
    top: 275px;
    left: 82px;
  }

  /* 调整箭头位置，避免重叠 */
  .left-arrow-1 {
    top: 5px;
    left: -90px;
  }
  .left-arrow-2 {
    top: 90px;
    left: -80px;
  }
  .left-arrow-3 {
    top: 160px;
    left: -100px;
  }
  .left-arrow-4 {
    top: 220px;
    left: -120px;
  }
  .right-arrow-1 {
    top: 70px;
    left: 130px;
  }
  .right-arrow-2 {
    top: 170px;
    left: 105px;
  }
  .right-arrow-3 {
    top: 250px;
    left: 115px;
  }

  /* 调整点的大小 */
  .point {
    width: 8px;
    height: 8px;
  }

  /* 调整文本间距 */
  .second-text {
    margin-bottom: 1rem;
  }
}
</style>
